export class LoanProcessingDefinitionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async validatePipelinesExpression(body) {
    return this.#http.post('/api/expressions/pipelines/validate', body);
  }

  async validatePipelinesPotentialExpression(body) {
    return this.#http.post('/api/expressions/pipelines/potential-expression', body);
  }

  async getMilestoneExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/milestones');
  }

  async getAppraisalProductExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/milestones');
  }

  async getTimedSequenceExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/timed-sequences');
  }

  async getLoanActionArithmeticOperationsExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/loan-action-arithmetic-operations');
  }
}
